import { render, staticRenderFns } from "./Customer-list.vue?vue&type=template&id=4abeb623&scoped=true&"
import script from "./Customer-list.vue?vue&type=script&lang=js&"
export * from "./Customer-list.vue?vue&type=script&lang=js&"
import style0 from "./Customer-list.vue?vue&type=style&index=0&id=4abeb623&lang=scss&scoped=true&"
import style1 from "./Customer-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abeb623",
  null
  
)

export default component.exports